import { useEffect } from 'react';
import { endGuidedJourney } from '../lib/guided-journey';

/** Entering the flow other than by guided planning's hand-over gives it back its own look. */
export function useEndGuidedJourney(clientId: string) {
  useEffect(() => endGuidedJourney(clientId), [clientId]);
}
